<template>
    <div v-title="$route.meta.title">
      <div class="page-heading">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="tablePath">员工管理</el-breadcrumb-item>
          <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <layout-panel :show-header="false" >
        <el-form ref="form"
                 :disabled="isOnlyView"
                 class="add-form"
                 :model="form"
                 :rules="formRules"
                 label-width="96px"
                 label-position="right"
                 size="medium"
                 @submit.native.prevent="onSubmit()">
          <el-form-item label="员工姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入员工姓名" clearable></el-input>
          </el-form-item>

          <el-form-item label="性别" prop="gender">
            <el-select v-model="form.gender" placeholder="请选择性别" class="width-max">
              <el-option label="男" value="1" />
              <el-option label="女" value="2" />
            </el-select>
          </el-form-item>

          <el-form-item label="手机号" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="email">
            <el-input v-model="form.email" placeholder="请输入邮箱" clearable></el-input>
          </el-form-item>

          <el-form-item label="周年密送" prop="hire_bcc">
            <div class="tag-input-wrap">
              <el-tag v-for="(item, idx) in form.hire_bcc"
                      :key="'hire-' + idx"
                      closable
                      size="small"
                      @close="removeBcc('hire_bcc', idx)">
                {{ item }}
              </el-tag>
              <el-input v-model="inputHireBcc"
                        placeholder="输入后回车或逗号添加"
                        size="small"
                        class="tag-input-inner"
                        @keydown.enter.native.prevent="addBccFromInput('hire_bcc', 'inputHireBcc')"
                        @keydown.native.188="addBccFromInput('hire_bcc', 'inputHireBcc')">
              </el-input>
            </div>
          </el-form-item>

          <el-form-item label="生日密送" prop="birthday_bcc">
            <div class="tag-input-wrap">
              <el-tag v-for="(item, idx) in form.birthday_bcc"
                      :key="'bd-' + idx"
                      closable
                      size="small"
                      @close="removeBcc('birthday_bcc', idx)">
                {{ item }}
              </el-tag>
              <el-input v-model="inputBirthdayBcc"
                        placeholder="输入后回车或逗号添加"
                        size="small"
                        class="tag-input-inner"
                        @keydown.enter.native.prevent="addBccFromInput('birthday_bcc', 'inputBirthdayBcc')"
                        @keydown.native.188="addBccFromInput('birthday_bcc', 'inputBirthdayBcc')">
              </el-input>
            </div>
          </el-form-item>

          <el-form-item label="生日" prop="birthday">
            <el-date-picker v-model="form.birthday"
                            type="date"
                            format="yyyy-MM-dd"
                            placeholder="请选择生日"
                            :picker-options="dateTimePickerOptions"
                            class="width-max">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="入职日期" prop="hire_date">
            <el-date-picker v-model="form.hire_date"
                            type="date"
                            format="yyyy-MM-dd"
                            placeholder="请选择入职日期"
                            :picker-options="dateTimePickerOptions"
                            class="width-max">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="员工状态" prop="status">
            <el-select v-model="form.status" placeholder="请选择员工状态" class="width-max">
              <el-option label="在职" value="1" />
              <el-option label="离职" value="2" />
              <el-option label="冻结" value="3" />
            </el-select>
          </el-form-item>

          <div class="footer" v-if="!isOnlyView">
            <el-button  type="primary" @click="onSubmit()">保存</el-button>
            <el-button @click="onBack()">返回</el-button>
          </div>
        </el-form>
      </layout-panel>
    </div>
  </template>


<script>
import { formRules } from '../../hr.rules'
import dateTimePicker from '@core/mixins/dateTimePicker'

export default {
  mixins: [dateTimePicker],
  data () {
    return {
      id: 0,
      isOnlyView: false,
      formRules,
      form: {
        name: '',
        gender: null,
        phone: '',
        email: '',
        birthday: null,
        hire_date: null,
        status: null,
        hire_bcc: [],
        birthday_bcc: [],
      },
      inputHireBcc: '',
      inputBirthdayBcc: '',
    }
  },
  computed: {
    isEdit () {
      return !!this.id
    },
    tablePath () {
      return '/hr/employee'
    },
  },
  created () {
    const id = this.$route.params.id
    this.isOnlyView = this.$route.meta.isOnlyView // 仅查看
    if (id) {
      this.id = id
      this.loadDetail()
    }
  },
  methods: {
    ...request.map([]),
    removeBcc (field, index) {
      this.form[field].splice(index, 1)
    },
    addBccFromInput (field, inputKey) {
      const raw = (this[inputKey] || '').trim()
      if (!raw) return
      const items = raw.split(',').map(s => s.trim()).filter(Boolean)
      items.forEach(item => {
        if (item && !this.form[field].includes(item)) {
          this.form[field].push(item)
        }
      })
      this[inputKey] = ''
    },
    loadDetail () {
      return request.page('getEmployeeDetail', this.id).then(({data}) => {
        // 回填基础字段
        filter.setLoop(this.form, data)
        // 日期字段：后端通常返回字符串，这里转换为 Date 供 date-picker 使用
        this.form.birthday = data.birthday ? moment(data.birthday, 'YYYY-MM-DD').toDate() : null
        this.form.hire_date = data.hire_date ? moment(data.hire_date, 'YYYY-MM-DD').toDate() : null
        this.form.hire_bcc = Array.isArray(data.hire_bcc) ? [...data.hire_bcc] : (data.hire_bcc ? [data.hire_bcc] : [])
        this.form.birthday_bcc = Array.isArray(data.birthday_bcc) ? [...data.birthday_bcc] : (data.birthday_bcc ? [data.birthday_bcc] : [])
      })
    },
    onBack () {
      this.$router.push(this.tablePath)
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        const payload = {
          ...this.form,
          birthday: this.form.birthday ? moment(this.form.birthday).format('YYYY-MM-DD') : '',
          hire_date: this.form.hire_date ? moment(this.form.hire_date).format('YYYY-MM-DD') : '',
          hire_bcc: this.form.hire_bcc || [],
          birthday_bcc: this.form.birthday_bcc || [],
        }
        // 编辑模式：带上 id，走 edit 接口
        if (this.isEdit) {
          request.common('editEmployee', {id: this.id, ...payload}).then(() => {
            this.$confirm('修改员工成功，是否返回列表页？', '提示', {type: 'success'}).then(() => {
              this.onBack()
            }).catch(() => {})
          })
          return
        }
        // 新增模式
        request.common('addEmployee', payload).then(() => {
          this.$confirm('新增员工成功，是否继续录入？', '提示', {type: 'success'}).then(() => {
            this.$refs.form.resetFields()
          }, () => {
            this.onBack()
          })
        })
      })
    },
  },
}
</script>


<style lang="scss" scoped>
.add-form {
  width: 500px;
  padding: 20px;
}
.tag-input-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  min-height: 36px;
  width: 100%;
}
.tag-input-wrap .tag-input-inner {
  flex: 1;
  min-width: 120px;
}
.tag-input-wrap .el-tag {
  margin: 0;
}
.footer {
  padding: 20px;
  display: flex;
  justify-content: flex-start;
  gap: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/hr/pages/employee/form.vue